export const manufacturingSelection = {
  continuousDyeing: 'Continuous dyeing',
  exhaustDyeing: 'Exhaust dyeing',
  laundry: 'Laundry',
  leather: 'Leather processing',
  overallPrinting: 'Overall printing',
  other: 'Dry Processes',
  positionalPrinting: 'Positional printing'
};
